import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-preparation',
  templateUrl: './catalogs-preparation.component.html',
  styleUrls: ['./catalogs-preparation.component.scss']
})
export class CatalogsPreparationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
